import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { SaveAssessmentParam } from "features/hr/core/hr.params";
import {
  SaveAssessmentRepository,
  SaveAssessmentResponse,
} from "features/hr/data/repository/hr-appraisal.repository";
import { RootState } from "features/config/store";

export enum SaveAssessmentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: SaveAssessmentState;
  message: string;
}

const initialState: InitialState = {
  status: SaveAssessmentState.initial,
  message: "",
};

export const saveAssessment = createAsyncThunk(
  "saveAssessment",
  async (param: SaveAssessmentParam, { rejectWithValue }) => {
    try {
      const response: SaveAssessmentResponse = await SaveAssessmentRepository(
        param
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        console.log(error);
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const saveAssessmentSlice = createSlice({
  name: "saveAssessment",
  initialState,
  reducers: {
    resetSaveAssessment: (state) => {
      state.status = SaveAssessmentState.initial;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveAssessment.pending, (state) => {
        state.status = SaveAssessmentState.inProgress;
      })
      .addCase(saveAssessment.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;

          state.status = SaveAssessmentState.success;
          state.message = message;
        }
      })
      .addCase(saveAssessment.rejected, (state, action) => {
        state.status = SaveAssessmentState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectSaveAssessment = (state: RootState) => state.saveAssessment;
export const { resetSaveAssessment } = saveAssessmentSlice.actions;

export default saveAssessmentSlice.reducer;
